
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import commonService from '../api/common.service';
import ProgrammeService from '../api/programme.service';
import { SUCCESS_STATUS } from '../utility/Constants';
import { Button, Typography, Space } from 'antd';
import logo from '../assets/images/logo.png'
import axios from 'axios';
import jwt_decode from "jwt-decode";

const { Title, Text } = Typography;


const Dashboard = () => {

  const buttonref = useRef(null);
  const [isPostReturnUrlAvailable, setIsPostReturnUrlAvailable] = useState(false);
  const [redirectLink, setRedirectLink] = useState('');
  const [User, setUser] = useState(null);
  const [year , setYear] = useState(null);

  const onPostClick = async () => {
    setIsPostReturnUrlAvailable(false)
    const formdata = {
      fromdate: '01/04/2022',
      todate: '31/03/2023',
      companyId: 1,
      yearid: 2,
      // account_id:10,
    }

    const response = ProgrammeService.testPost(formdata).then((resdata) => {
      let dataPdf = resdata.data;
      setIsPostReturnUrlAvailable(true)
      //buttonref.current.click();
      // console.log("Link = ",resdata.data.link)
      console.log(resdata)
      let url = "http://btaportal.in/custom/report/" + resdata.data.link
      setRedirectLink(url)


    });
  };


  // const base64toBlob = (base64Data) => {
  //   console.log("Base64",base64Data)
  //   const sliceSize = 1024;
  //   const byteCharacters = atob(base64Data);
  //   const bytesLength = byteCharacters.length;
  //   const slicesCount = Math.ceil(bytesLength / sliceSize);
  //   const byteArrays = new Array(slicesCount);

  //   for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
  //     const begin = sliceIndex * sliceSize;
  //     const end = Math.min(begin + sliceSize, bytesLength);

  //     const bytes = new Array(end - begin);
  //     for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
  //       bytes[i] = byteCharacters[offset].charCodeAt(0);
  //     }
  //     byteArrays[sliceIndex] = new Uint8Array(bytes);
  //   }
  //   return new Blob(byteArrays, { type: "application/pdf" });
  // }

  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  useEffect(() => {
    if (isPostReturnUrlAvailable) {
      buttonref.current.click();
    }

  }, [isPostReturnUrlAvailable])

  useEffect(() => {
    // get token from local storage
    let user = localStorage.getItem('user');
    if (user) {
      const userObject = JSON.parse(user);
      let { token } = userObject
      console.log(token)
      if (token) {
        const decodedToken = jwt_decode(token);
        console.log(decodedToken); // This will log the decoded token information
        // You can access specific user info like this:
        const username = decodedToken.username; // Adjust based on your token structure
        console.log("Username:", username);
        setUser(username)
        setYear(decodedToken.yearData.year)
      }
    }
  }, [])


  const containerStyle = {
    position: "relative",
    width: "100vw", // Full width of the viewport
    height: "93vh", // Full height of the viewport
    backgroundColor: "#e3d8b0", // Updated background color
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  };

  const backgroundEffectStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%", // Ensure it spans the entire container
    height: "100%", // Ensure it spans the entire container
    backgroundColor: "#fff", // Light white effect
    backgroundSize: "20px 20px",
    opacity: 0.2,
    filter: "blur(100px)",
  };

  const contentStyle = {
    position: "relative",
    textAlign: "center",
    zIndex: 10,
    right: "10%",
  };

  const titleStyle = {
    fontSize: "2rem",
    fontWeight: "900",
    textTransform: "uppercase",
    userSelect: "none",
    color: "#685211", 
  };

  const yearStyle = {
    fontSize: "1.5rem",
    fontWeight: "900",
    textTransform: "uppercase",
    color: "#685211", 
    userSelect: "none",
  };

  const userDetailsStyle = {
    fontSize: "1.5rem",
    fontWeight: "900",
    color: "#685211", 
    marginTop: "2rem",
    userSelect: "none",
  };

  // <>
  //     <div style={{
  //       position: 'relative',
  //       display: 'flex',
  //       height: '100%',
  //       alignItems: 'center',
  //       overflow: 'hidden'
  //     }}>
  //       <div style={{ textAlign: 'center', marginLeft: 'auto', marginRight: 'auto' }}>
  //         {/* <img src={logo} className="sidebar-logo" alt="logo" /> */}
  //         <h3 style={{
  //           fontSize: '4rem',
  //           fontWeight: '900',
  //           textTransform: 'uppercase',
  //           textShadow: '5px 2px 1px #c0d9a1',
  //           color: '#1a8811',
  //           marginTop: '5rem'
  //         }}>Welcome To BTA Portal</h3>

  //         {/* user details */}
  //         <p style={{
  //           fontSize: '4rem',
  //           fontWeight: '900',
  //           textShadow: '5px 2px 1px #c0d9a1',
  //           color: '#1a8811',
  //           marginTop: '5rem'
  //         }}>Logged in by: <span>{User}</span></p>




  //       </div>
  //     </div>
  //   </>

  return (
    <div style={containerStyle}>
      {/* Background Effect */}
      <div style={backgroundEffectStyle}></div>

      {/* Content */}
      <div style={contentStyle}>
        <h3 style={titleStyle}>Bengal Tennis Association</h3>
        <h3 style={yearStyle}>{year}</h3>

        {/* User Details */}
        <p style={userDetailsStyle}>
          <span>Welcome - {User}</span>
        </p>
      </div>
    </div>
  );
}

export default Dashboard